import { render, staticRenderFns } from "./rm-set-driver-parameters-modal.vue?vue&type=template&id=1316d1e4&"
import script from "./rm-set-driver-parameters-modal.vue?vue&type=script&lang=js&"
export * from "./rm-set-driver-parameters-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports